export type SharedReference = { text: string; url: string };

type NoteDefinitions = {
  notes: Record<string, string>;
  references: Record<string, SharedReference>;
};

export const noteDefinitions: NoteDefinitions = {
  notes: {
    'index-values': 'Index values are 100 based, with the national average=100. A value of 50 indicates one-half the national average, and a value of 200 indicates twice the national average.',
    'daytime-population': 'Daytime population consists of the persons employed in the study area, children aged 0-15, and persons 16+ not employed (civilian or armed forces).',
    'area-approximate': 'Area is approximate only and excludes internal water areas.',
    'dollar-data-current': 'All dollar related data - income, expenditures, rent, housing values, retail sales, etc. - are reported in current (nominal), not constant (inflation-adjusted) dollars.',
    'monetary-currency': 'Monetary values are shown in the local currency of the selected location.',
    'business-establishment-devonshire': 'Business establishment data: Devonshire Associates dmPlus.',
    'poverty-levels': 'Poverty levels are defined by the US Census Bureau using standard census based income thresholds across forty-eight household groupings, categorised by family size and regional context (urban/non-urban).',
    'non-resident-population': 'Non-Resident population estimates are presented as nightly average values, relative to the period specified (e.g. annual or quarterly).',
    'income-inequality': 'Income inequality measures are based on the Gini coefficient, which measures deviation from a uniform cumulative distribution. Range is 0 to 1, where 0 represents perfect equality and 1 represents perfect inequality.',
    'diversity-index': 'Diversity measures the probability that two randomly selected individuals belong to different racial/ethnic groups. A value of 0 indicates no diversity, and a value of 1 indicates maximum diversity.',
    'cooling-degree-days': 'Cooling degree days are the annual total of the daily difference between the daily high temperature and 68°F. Higher values indicate higher anticipated cooling requirements.',
    'heating-degree-days': 'Heating degree days are the annual total of the daily difference between the daily low temperature and 68°F. Higher values indicate higher anticipated heating requirements.',
    'index-values-logarithmic': 'Scale index values range from 0-10 on a logarithmic scale.',
    'sample-data-preliminary': 'Sample Data Only. Final indexes for 2022A may be different.',
    'plant-hardiness-zones': 'Plant Hardiness Zones are defined by the normal average minimum temperature (average coldest night of the year).',
    'koppen-climate-classification': 'See https://en.wikipedia.org/wiki/Koppen_climate_classification for definitions and descriptions of climate classification.',
    'epa-walkability': 'See https://www.epa.gov/smartgrowth for discussion of walkability (range 0-20) and smart locations coefficient (0-100).',
    'measurements-kwh': 'Measurements are in kWh/meter squared per day.',
    'ancestry-multiple-responses': 'Ancestry counts do not add to the total population since multiple responses are permitted.',
    'linguistic-isolation': 'A household is linguistically isolated unless at least one member aged 14 or over speaks only English, or speaks English "very well" in addition to another language.',
  },
  references: {
    'ags-estimates-projections': {
      text: 'AGS Estimates and Projections Methodology 2026A',
      url: 'https://appliedgeographic.com/wp-content/uploads/2026/04/AGS-Estimates-and-Projections-Methodology-2026A.pdf',
    },
    'ags-business-counts': {
      text: 'AGS Business Counts Methodology 2026A',
      url: 'https://appliedgeographic.com/wp-content/uploads/2026/04/AGS-BusinessCounts-Methodology-2026A.pdf',
    },
    'ags-environmental': {
      text: 'AGS Environmental 2026A',
      url: 'https://appliedgeographic.com/wp-content/uploads/2026/04/AGS-Environmental-2026A.pdf',
    },
    'ags-crime-risk': {
      text: 'AGS Crime Risk Methodology 2026A',
      url: 'https://appliedgeographic.com/wp-content/uploads/2026/04/AGS-CrimeRisk-Methodology-2026A.pdf',
    },
    'ags-health-care': {
      text: 'AGS Health Care 2026A',
      url: 'https://appliedgeographic.com/wp-content/uploads/2026/04/AGS-Health-Care-2026A.pdf',
    },
    'ags-vital-statistics': {
      text: 'AGS Vital Statistics Methodology 2026A',
      url: 'https://appliedgeographic.com/wp-content/uploads/2026/04/AGS-Vital-Statistics-Methodology-2026A.pdf',
    },
    'ags-consumer-expenditures': {
      text: 'AGS Consumer Expenditures, Retail Potential and Retail Gap Methodology 2026A',
      url: 'https://appliedgeographic.com/wp-content/uploads/2026/04/AGS-Consumer-Expenditures-Retail-Potential-and-Retail-Gap-Methodology-2026A.pdf',
    },
    'epa-smart-growth': {
      text: 'EPA Smart Growth',
      url: 'https://www.epa.gov/smartgrowth',
    },
    'ags-non-resident-population': {
      text: 'AGS Non-Resident Population Methodology 2026A',
      url: 'https://appliedgeographic.com/wp-content/uploads/2026/04/AGS-Non-Resident-Population-Methodology-2026A.pdf',
    },
  },
};
